export default {choose_newsletter:'Vælg nyhedsbreve fra listen.',email_please:'Din e-mail?'};